import { motion } from "framer-motion";
import { Car, ShieldCheck, Lock, CalendarClock, CreditCard, BadgeCheck, Clock, HeartHandshake } from "lucide-react";

const reasons = [
  { icon: Car, t: "Mobile Service", d: "I come to you for total convenience." },
  { icon: BadgeCheck, t: "Professional", d: "Courteous, polished, detail-driven service." },
  { icon: Lock, t: "Confidential", d: "Your documents stay private and secure." },
  { icon: Clock, t: "Same-Day Appointments", d: "Available when scheduling allows." },
  { icon: CalendarClock, t: "Flexible Scheduling", d: "Evenings and weekends available." },
  { icon: CreditCard, t: "Secure Payments", d: "Cash, card, Zelle and more accepted." },
  { icon: ShieldCheck, t: "Reliable Service", d: "On time, every time, as promised." },
  { icon: HeartHandshake, t: "Customer-Focused", d: "A warm, tailored client experience." },
];

export const WhyChoose = () => {
  return (
    <section className="relative bg-ink text-ivory py-24 lg:py-32 overflow-hidden" data-testid="why-choose-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] rounded-full bg-gold/5 blur-[140px]" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="eyebrow text-gold mb-4">Why Choose Me</p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight">
            The MB Notary <span className="gold-text italic">Difference</span>
          </h2>
          <span className="block w-16 h-px bg-gold mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-gold/15 rounded-2xl overflow-hidden border border-gold/15">
          {reasons.map((r, i) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.t}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
                className="group bg-ink hover:bg-[#262626] transition-colors duration-500 p-7 sm:p-8"
                data-testid={`reason-${i}`}
              >
                <div className="h-12 w-12 rounded-full border border-gold/30 grid place-items-center mb-5 group-hover:scale-110 group-hover:border-gold transition-all duration-500">
                  <Icon size={22} strokeWidth={1.3} className="text-gold" />
                </div>
                <h3 className="font-serif text-lg mb-2">{r.t}</h3>
                <p className="text-ivory/55 text-sm font-light leading-relaxed">{r.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
